const pathToCoachOrgId = {
  dev: {
    'desmond_scott': '-L5k9mD8k3PLJCEaw0Jn',
    'bodyweight_warrior': '-LT477BU7OW8AglPgFlf',
    'hana_milly': '-LmVplLkkVMZbzJStwE7',
    'double_aacademy': '-LT477BU7OW8AglPgFlg',
    'rebecca_beckler': '-LmVplLkkVMZbzJStwD8',
    'john_lindsey': '-MT477BU7OW8AglPgFla',
    'valeria_garcia': '-MT477BU7OW8AglPgFlb',
    'carlos_concepcion': '-MT477BU7OW8AglPgFlc',
    'zackheight': '-NXP2CPfFLOaco88xmPm'
  },
  prod: {
    'desmond_scott': '-LW2M4tJakuYczP6HfZr',
    'bodyweight_warrior': '-LW2M4tJakuYczP6HfZq',
    'double_aacademy': '-LW2M4tJakuYczP6HfZs',
    'hana_milly': '-LW2M4tJakuYczP6HfZt',
    'minusthegym': '-LW2M4tJakuYczP6HfZu',
    'rebecca_beckler': '-LW2M4tJakuYczP6HfZv',
    'john_lindsey': '-LW2M4tJakuYczP6HfZx',
    'valeria_garcia': '-LW2M4tJakuYczP6HfZy',
    'carlos_concepcion': '-MW2M4tJakuYczP6HfZa',
    'slava_goloubov': '-MW2M4tJakuYczP6HfZd',
    'ollie_frost': '-MW2M4tJakuYczP6HfZh',
    'luca_ernst': '-MW2M4tJakuYczP6HfZc',
    'anna_davey': '-LW2M4tJakuYczP6HfZz',
    'siawn_ou': '-MW2M4tJakuYczP6HfZf',
    'levi_reiling': '-MW2M4tJakuYczP6HfZm',
    'micki_harvard': '-MW2M4tJakuYczP6HfZl',
    'tome_tao': '-MW2M4tJakuYczP6HfZg',
    'sid_paulson': '-MW2M4tJakuYczP6HfZo',
    'johanna_scholz': '-MW2M4tJakuYczP6HfZn',
    'shaquille_miller': '-MW2M4tJakuYczP6HfZk',
    'gabi_butler': '-MW2M4tJakuYczP6HfZv',
    'kelli_bettridge': '-MW2M4tJakuYczP6HfZt',
    'movement_collective': '-MW2M4tJakuYczP6HfZr',
    'babi_manu': '-MW2M4tJakuYczP6HfZz',
    'jared_feather': '-MW2M4tJakuYczP6HfZw',
    'geraldo_alken': '-MW2M4tJakuYczP6HfZy',
    'layla_luciano': '-NW2M4tJakuYczP6HfZc',
    'ochir_ub': '-NW2M4tJakuYczP6HfZb',
    'amanda_essen': '-NW2M4tJakuYczP6HfZa',
    'whitney_jones': '-NW2M4tJakuYczP6HfZe',
    'michael_nunziata': '-NW2M4tJakuYczP6HfZf',
    'sondre_berg': '-MW2M4tJakuYczP6HfZx',
    'leandro_fornito': '-NW2M4tJakuYczP6HfZi',
    'derek_williams': '-NW2M4tJakuYczP6HfZj',
    'hilal_leigh': '-NW2M4tJakuYczP6HfZg',
    'theo_necker': '-NPy08dgDfhtH4KpHGUW',
    'peacock_pilates': '-NTsm_gu31zALMfL9zla',
    'maestro_workout': '-NU7X55l_G5VQzJP96Td',
    'baseblocks': '-NNJaFoGcfkDOcu9aMkk',
    'prosper_fitness': '-NRj4mDf2-4RaWWeOl3F',
    'brittany_cates': '-NVqkfaMHBdHI8-Tgciq',
    'kettlebell_therapy': '-NSvqbXoz67Dmw-HvtWx',
    'theflexibilityguy': '-NSNflFAV4s0uAPWRjiO',
    'zackheight': '-NReFHDhUE-T9jrURbYK',
    'striqfit': '-NXblI7t9ptldXmxexJX',
    'noelcomfit': '-NWEk5RUNhTt5jmYFX94',
    'ftelevate': '-NaRc11klV_OMSJEvYF6',
    'paultwyman': '-NYwAx522fNtBvdTH6gZ',
    'andrystrong': '-NU9ZgQVDtia7Oe2wOzy',
    'abbie_hudson': '-NahkA205PMoV51GoO38',
    'xavier_cormier': '-N_ZXyyd9J4SUkeXAoXx',
    'asia_roberson': '-N_qQDKa8NlX0Wb3d0Lb',
    'yuri_carvalho': '-NciBr7KIsTak2GiI3gE',
    'charell_berg': '-NSwo9TlhocvVcyWdR5V',
    'feetup': '-NcUDKiuheE8aswVXrqW',
    'nadine_hettinga': '-NbLOeHDbAEgcL02DxdI',
    'woo_sah': '-NhXA_LH3NVMnIKe4M0V',
    'laura_kummerle': '-NibzYAz4PSzmclOJPfC',
    'embracemovement': '-NkPMsdor32P-x7uNBtO',
    'omarfit': '-NVMnSvp3AD_O8XeLaW0',
    'kickassyoga': '-NrLkIcDicvYWC1G1qvm',
    'cheyenne_gonzalez': '-Nv-MgJ29iRJlMz1EaYb',
    'trickvault': '-NsDkDRUpnrMQAudNHb2',
    'christiancruz': '-NxMcQ74JJZ01abN-T6w',
    'arielrodriguez': '-NkWjMak_O6-zFEN8JCs',
    'alexandrosthenics': '-NxSCRa9f3_DX7wAglII',
    'movewithnevin': '-O-2rdZshgzK230zlwUN',
    'brennanmejia': '-Nwjiw8fHsXpNyZYkBNZ',
    'calitokyo': '-Nz8o6sj511Dof6-OpBN',
    'jeffskamalo': '-NrGcSVtavAvQxmp9gTp',
    'aleksandrbatuev': '-Nw-hbEbGEaFpoUChI9W',
    'chrisharriz': '-Nwu8CAjd1BP46kkJsBY',
    'paulinaroquett': '-Ny-qvhfncjVJnRmM18m',
    'simondingemans': '-NxRdWXamvIZWGIvPovD',
    'aniamoves': '-O31qo6ZSkvjgEh5MFFk',
    'shapeshiftguide': '-NyVaBpG4Wb5xtl1LAJq',
    'athletistry': '-O31ks9Ewlp3hgEGfCD_',
    'strongandmobile': '-NwFQMfhJm5IUQv52KoJ',
    'lineup': '-O2xq_oTfBLlHRH13Q9k',
    'andriibondarenko': '-O5HxSyzGsVUSqq3C1RY',
    'sofyayokoyama': '-O6uykk1XCBw_9aAwfyc',
    'nathan': '-O9Au8e8j1n4pP57D7xI',
    'sifunate': '-O8pLDmL97A0FCh2igEw',
    'valeriebrown': '-O60mR2TS445zkVw6c6y',
    'physicalempowerment': '-OCiFZdG0YVZvosvAjY0',
    'nalamoves': '-O2a0mIIz9yhq0dj8B63',
  }
};

export default pathToCoachOrgId;


// WEBPACK FOOTER //
// ./src/domains/PathToCoachOrgId.js